import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';
import LocalAuthority from '../../model/local-authority';

const LOCAL_AUTHORITIES = 'localauthorities';

export default class LocalAuthoritiesService extends SfpBaseService {
	/**
	 * @returns {Promise<LocalAuthority[]>}
	 */
	static findAllLocalAuthorities() {
		return fetch(`${apiBaseUrl}/${LOCAL_AUTHORITIES}`, {headers: getBaseHeader()})
			.then(response => {
				const json = super.returnResponse(response);
				return json.then(body => body.map(la => LocalAuthority.createFromJson(la)))
			});
	}

	/**
	 * @param {LocalAuthority} localAuthority
	 */
	static createLocalAuthority(localAuthority) {
		const data = localAuthority.bergerLevrault ? {
			name       : localAuthority.name,
			code       : localAuthority.code,
			bergerLevrault: {
				code: localAuthority.bergerLevrault,
				enabled: true
			},
			instruction: localAuthority.instruction.id,
			accounts   : localAuthority.accounts.map(a => ({
				account: a.account.id,
				chapter: a.chapter && a.chapter.id
			}))
		} : {
			name       : localAuthority.name,
			code       : localAuthority.code,
			instruction: localAuthority.instruction.id,
			accounts   : localAuthority.accounts.map(a => ({
				account: a.account.id,
				chapter: a.chapter && a.chapter.id
			}))
		}

		const body = JSON.stringify({localAuthority: data});
		const headers = {
			...getBaseHeader(),
			'Content-Type': 'application/json'
		};
		const method = 'POST';

		return fetch(`${apiBaseUrl}/${LOCAL_AUTHORITIES}`, {body, headers, method})
			.then(super.returnResponse);
	}

	static findLocalAuthorityByIdOrSlug(localAuthorityId) {
		return fetch(`${apiBaseUrl}/${LOCAL_AUTHORITIES}/${localAuthorityId}`, {headers: getBaseHeader()})
			.then(response => {
				const json = super.returnResponse(response);
				return json.then(body => LocalAuthority.createFromJson(body));
			});
	}
}


// WEBPACK FOOTER //
// ./src/service/sfp/local-authorities-service.js